import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 50 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  "clip-path": "#clip0_409_21",
  stroke: "#fff",
  "stroke-width": "1.5"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M24.758 48.766a24.007 24.007 0 1 0 0-48.015 24.007 24.007 0 0 0 0 48.015Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M24.758 11.512v13.246l6.623 6.623" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };